import SearchIcon from "@mui/icons-material/Search";
import {
  FormControl,
  InputAdornment,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import * as React from "react";
import "./search.css";

export default function SearchBar(props) {
  const { onChange } = props;
  const [value, setValue] = React.useState("");

  return (
    <FormControl variant="outlined" sx={{ minheight: "1rem", width: "75%",margin:"8px" }}>
      <OutlinedInput
        id="search-input-box"
        onChange={(e) => {
          setValue(e.target.value);
        }}
        value={value}
        sx={{ minheight: "1rem", width: "100%",borderRadius:"50px",padding:"0px 15px"}}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              m={1}
              onClick={() => {onChange({ label: value }) ; setValue("")}}
              edge="end"
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        variant="outlined"
      />
    </FormControl>
  );
}
